import { setImportDryRun } from './updateMigrationService';
import retryImport from './retryImportService';
import type { RetryImportResult } from './retryImportService';

/**
 * Converts a completed dry-run preview into a real import on the SAME migration: clears the dry-run
 * flag, then re-enqueues the import (reusing the already exported + transformed artifacts). Idempotent —
 * import-block adoption re-adopts any resources that already exist in the target org.
 */
export const runRealImport = async (
  bearerToken: string,
  migrationId: string
): Promise<RetryImportResult> => {
  await setImportDryRun(bearerToken, migrationId, false);
  return retryImport(bearerToken, migrationId);
};

export default runRealImport;
